import React from 'react';
import ImageUploadCropper from '../Shared/ImageUploadCropper';
import DefaultImage from '../../assets/default-image.png';

interface Props {
  // 🔹 Logo para tickets
  logoFile: File | null;
  logoPreviewUrl?: string;
  setLogoFile: (file: File | null) => void;

  // 🔹 Logo para documentos DTE
  pdfLogoFile: File | null;
  pdfLogoPreviewUrl?: string;
  setPdfLogoFile: (file: File | null) => void;
}

const BusinessLogosUploader: React.FC<Props> = ({
  logoFile,
  logoPreviewUrl,
  setLogoFile,
  pdfLogoFile,
  pdfLogoPreviewUrl,
  setPdfLogoFile,
}) => {
  // ✅ Generar previews
  const previewTicketLogo = logoFile
    ? URL.createObjectURL(logoFile)
    : logoPreviewUrl || DefaultImage;

  const previewPdfLogo = pdfLogoFile
    ? URL.createObjectURL(pdfLogoFile)
    : pdfLogoPreviewUrl || DefaultImage;

  return (
    <div className="mb-6">
      <h2 className="text-gray-800 mb-4 text-center text-lg font-semibold dark:text-white">
        Configuración de Logos
      </h2>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* 🔹 Logo para Ticket */}
        <div className="flex flex-col items-center">
          <h3 className="mb-3 text-base font-medium text-gray-700 dark:text-gray-200">
            Logo para Ticket
          </h3>
          <ImageUploadCropper
            label=""
            currentImage={previewTicketLogo}
            onUpload={(file) => setLogoFile(file)}
            onDelete={() => setLogoFile(null)}
          />
        </div>

        {/* 🔹 Logo para Documentos DTE */}
        <div className="flex flex-col items-center">
          <h3 className="mb-3 text-base font-medium text-gray-700 dark:text-gray-200">
            Logo para Documentos DTE
          </h3>
          <ImageUploadCropper
            label=""
            currentImage={previewPdfLogo}
            onUpload={(file) => setPdfLogoFile(file)}
            onDelete={() => setPdfLogoFile(null)}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessLogosUploader;
